import React, { useState } from "react"
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  // MDBModalFooter,
  MDBCardImage,
} from "mdb-react-ui-kit"

export default function ModalDetalle({
  title,
  logoSrc,
  countryName,
  cityName,
  resumen,
  mensaje,
  ingles
}) {
  const [basicModal, setBasicModal] = useState(false)

  const toggleShow = () => setBasicModal(!basicModal)

  return (
    <>
      <button
        onClick={toggleShow}
        className="botonregrcos"
        style={{
          maxHeight: "2.5em",
          width: "8em",
          borderRadius: "50px",
          background: "",
        }}
      >
        {mensaje}
      </button>
      <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader style={{ borderBottom: "none" }}>
              <MDBModalTitle
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "65px",
                }}
              >
                <MDBCardImage
                  alt=""
                  src={logoSrc}
                  style={{ margin: "0 10px", height: "100%" }}
                />
                <span style={{ color: "#707070", fontSize: "24px" }}>
                  {title}
                </span>
              </MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <table
                className="table table-borderless"
                style={{ color: "#707070" }}
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th
                      scope="col"
                      style={{ fontWeight: "normal", color: "#707070" }}
                    >
                      {countryName}
                    </th>
                    <th scope="col">{cityName}</th>
                  </tr>
                </thead>
                <tbody>
                  {resumen.destino &&
                    Object.keys(resumen.destino).map((key) => (
                      <tr key={key}>
                        <td style={{ textAlign: "left" }}>
                          {ingles === 1 ? resumen.destino[key].nombre_rubro_en : resumen.destino[key].nombre_rubro}
                        </td>
                        <td
                          style={{
                            borderLeft: "2px dashed #b0b0b0",
                            borderRight: "2px dashed #b0b0b0",
                            color: "#707070",
                          }}
                        >
                          ${resumen.origen[key].precio}
                        </td>
                        <td style={{ fontWeight: "bold" }}>
                          ${resumen.destino[key].precio}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div
                style={{
                  color: "#A09D9D",
                  textAlign: "left",
                  justifySelf: "flex-start",
                  width: "100%",
                  fontSize: "14px",
                  marginBottom: "14px",
                }}
              >
                {ingles === 1 ? "*All prices are in dollars" : "*Todos los precios se encuentran en dólares"}

                
              </div>
            </MDBModalBody>
            {/* <MDBModalFooter>
              <MDBBtn
                color="secondary"
                onClick={toggleShow}
                style={{ maxHeight: "2.5em", width: "5em" }}
              >
                Cerrar
              </MDBBtn>
            </MDBModalFooter> */}
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  )
}
